<div class="orders-list">
  <div
    class="order-line-sticky-header d-flex align-items-center justify-content-between"
    [ngClass]="{ 'pb-3': summaryPage }">
    <div class="align-items-center d-flex gap-2">
      <div><h2 *ngIf="summaryPage" class="mb-0">Line items</h2></div>

      <div *ngIf="smallLoader">
        <jni-spinner></jni-spinner>
      </div>
    </div>

    <div
      *ngIf="summaryPage"
      class="orders-panel col-auto d-flex justify-content-between align-items-center">
      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="toggleShowAllLines()">
          {{ showAllLinesFlag ? "Hide Deleted Lines" : "Show All Lines" }}
        </a>
      </div>
      <div
        *ngIf="!isDisableLink"
        class="ms-3 nav-link p-0 d-flex align-items-center delete">
        <div>
          <a
            [ngClass]="selectedLineItem?.length ? 'link' : 'link-disable'"
            class="link"
            class="delcol"
            (click)="onDrop()"
            ><i class="pi pi-trash"></i> Delete</a
          >
        </div>
      </div>
      <div
        *ngIf="!isDisableLink && salesOrderIdD365 !== ''"
        class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="getNonAddedSalesOrderLines()">
          <i class="pi pi-plus"></i> Add Lines</a
        >
      </div>
      <div
        *ngIf="!isDisableLink"
        class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="uploadTracking()"
          ><i class="pi pi-cloud-upload"></i> Upload Tracking</a
        >
      </div>

      <div
        *ngIf="!isDisableLink"
        class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="showTrackingPopup('add')"
          ><i class="pi pi-plus"></i> Add Tracking</a
        >
      </div>
    </div>
  </div>
  <p-table
    #dt
    stripedRows
    [rowHover]="true"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    [size]="'small'"
    [resizableColumns]="true"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    selectionMode="multiple"
    [value]="orderLines"
    [(selection)]="selectedLineItem"
    editMode="row"
    styleClass="table-listing"
    dataKey="lineRecIdD365">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th *ngIf="summaryPage"></th>
        <th *ngIf="summaryPage">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th *ngIf="summaryPage" class="notes">Entry Date</th>
        <th *ngIf="summaryPage" class="vendor-name">PO#</th>
        <th class="status">Supplier</th>
        <th class="notes">Nickname</th>
        <th class="status header">Status</th>
        <th class="status header">ESD</th>
        <th class="notes">Method</th>
        <th class="unmatched">Tracking</th>
        <th class="notes">Shipping Status</th>
        <th class="status header">IHD</th>
        <th *ngIf="summaryPage" class="status">Notifications</th>
        <th class="notes">Tasked</th>
        <th *ngIf="summaryPage">Note</th>
        <th *ngIf="summaryPage"></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-orderLines
      let-ri="rowIndex"
      let-editing="editing">
      <ng-container>
        <tr
          [ngClass]="{ odd: !getOddEvenNumber(ri), even: getOddEvenNumber(ri) }"
          class="p-selectable-row"
          [pSelectableRow]="orderLines"
          [pEditableRow]="orderLines">
          <td *ngIf="summaryPage">
            <!-- <p-button
              label="Submit"
              [disabled]="isDisableLink"
              *ngIf="!editing && orderLines.isActive"
              icon="pi pi-pencil"
              (click)="editLine(orderLines.lineRecIdD365)" /> -->

            <p-button
              [disabled]="isDisableLink"
              *ngIf="!editing && orderLines.isActive"
              icon="pi pi-pencil"
              (click)="editLine(orderLines.lineRecIdD365)"
              [rounded]="true"
              [text]="true" />

            <!-- <button
              [disabled]="isDisableLink"
              *ngIf="!editing && orderLines.isActive"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text"
              (click)="editLine(orderLines.lineRecIdD365)"></button> -->
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(orderLines)"
              class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color selectable-color"></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-danger"
              (click)="refreshGrid()"></button>
          </td>
          <td *ngIf="summaryPage">
            <p-tableCheckbox
              [value]="orderLines"
              [pEditableRow]="orderLines"
              [pSelectableRow]="orderLines"></p-tableCheckbox>
          </td>
          <td *ngIf="summaryPage">
            {{ orderLines.entryDate | date: "MM-dd-yyyy" }}
          </td>
          <td *ngIf="summaryPage">{{ orderLines.purchaseOrderD365 }}</td>
          <td>{{ orderLines.vendorNameD365 }}</td>
          <td
            class="text-truncate max-width-10"
            pTooltip="{{ orderLines.nickName }}"
            tooltipPosition="top"
            placeholder="top">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  style="width: 5rem"
                  [(ngModel)]="orderLines.nickName"
                  class="form-control"
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ orderLines.nickName }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td
            [ngClass]="{
              warning: getLineStatusHighlight(orderLines.lineStatus),
            }"
            pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  class="custom-ng-select"
                  appendTo="body"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="orderLines.lineStatus"
                  notFoundText="No Status Found"
                  (onClick)="$event.stopPropagation()"
                  (onChange)="onWorkflowLineStatusChange($event, orderLines)"
                  [options]="statusList"
                  optionValue="id">
                  <ng-template #selectedItem let-selectedOption>
                    <span
                      [ngClass]="{
                        'selected-status':
                          statusListMapping.indexOf(selectedOption.id) <
                          orderLines.lineStatus + 1,
                      }"
                      >{{ selectedOption.status }}</span
                    >
                  </ng-template>
                  <ng-template let-element #item>
                    <span
                      [ngClass]="{
                        'selected-status':
                          statusListMapping.indexOf(element.id) <
                          orderLines.lineStatus + 1,
                      }"
                      >{{ element.status }}</span
                    >
                  </ng-template>
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ getStatus(orderLines.lineStatus) }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td [ngClass]="getLineESDClass(orderLines)" pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-datePicker
                  [(ngModel)]="orderLines.shipDateD365"
                  [showButtonBar]="false"
                  [inputStyle]="{ height: '30px' }"
                  [style]="{ width: '100%' }"
                  [appendTo]="'body'"
                  dateFormat="mm-dd-yy"
                  (onSelect)="onShipDateSelection($event, orderLines)"
                  (onShow)="
                    onWorkflowListESDDateEdit(
                      orderLines.shipDateD365,
                      orderLines
                    )
                  ">
                </p-datePicker>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="orderLines.shipDateD365 | hidedynamicsdate">
                  {{ orderLines.shipDateD365 | date: "MM-dd-yyyy" }}
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>{{ orderLines.shippingMethod }}</td>
          <td [ngClass]="getLineTrackingClass(orderLines)">
            <a class="link" (click)="showTrackingDetailList(orderLines)">{{
              orderLines.trackingCount
            }}</a>
          </td>
          <td>
            <p-popover
              #trackingTooltip
              [style]="{ width: '30px', height: '60px' }"
              styleClass="tracking-popup">
              <ng-template pTemplate>
                <div class="row">
                  <p>
                    <strong>Status</strong><br />
                    <span *ngIf="orderLines.deliveredCount !== 0"
                      >Delivered: {{ orderLines.deliveredCount }}/{{
                        orderLines.trackingCount
                      }}</span
                    >
                    <span *ngIf="orderLines.inTransitCount !== 0"
                      >In-Transit: {{ orderLines.inTransitCount }}/{{
                        orderLines.trackingCount
                      }}</span
                    >
                    <span *ngIf="orderLines.shippedCount !== 0"
                      >Shipped: {{ orderLines.shippedCount }}/{{
                        orderLines.trackingCount
                      }}</span
                    >
                    <span *ngIf="orderLines.exceptionCount !== 0"
                      >Exception: {{ orderLines.exceptionCount }}/{{
                        orderLines.trackingCount
                      }}</span
                    >
                  </p>
                </div>
              </ng-template>
            </p-popover>
            <div
              class="clickable"
              #chartClick
              *ngIf="orderLines"
              (click)="trackingTooltip.toggle($event)">
              <p-chart
                type="bar"
                width="125px"
                height="50px"
                [data]="orderLines.stackedDataOptions"
                [options]="orderLines.chartOptions"></p-chart>
            </div>
          </td>
          <td [ngClass]="getLineIHDClass(orderLines)">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-datePicker
                  [(ngModel)]="orderLines.inHandDate"
                  [showButtonBar]="false"
                  [inputStyle]="{ height: '30px' }"
                  [style]="{ width: '100%' }"
                  [appendTo]="'body'"
                  dateFormat="mm-dd-yy"
                  (onSelect)="onInHandDateSelection($event, orderLines)"
                  [minDate]="inHandDateCurrentdate">
                  <ng-template pTemplate="footer">
                    <div class="d-flex align-items-center">
                      <p-checkbox
                        [(ngModel)]="orderLines.isFirmInHand"
                        binary="true"
                        [inputId]="
                          'isFirmCheckbox' + orderLines.lineRecIdD365
                        "></p-checkbox>
                      <label
                        class="ms-2"
                        [for]="'isFirmCheckbox' + orderLines.lineRecIdD365">
                        Is Firm
                      </label>
                    </div>
                  </ng-template>
                </p-datePicker>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="orderLines.inHandDate | hidedynamicsdate">
                  {{ orderLines.inHandDate | date: "MM-dd-yyyy" }}
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td *ngIf="summaryPage">
            <a
              class="link"
              (click)="
                isDisableLink
                  ? $event.preventDefault()
                  : getNotificationSettings(orderLines)
              "
              >Edit</a
            >
          </td>
          <td *ngIf="summaryPage">
            <a
              class="link"
              *ngIf="!orderLines.hasTask"
              (click)="createProductionTask(orderLines)"
              >Create</a
            >
            <span *ngIf="orderLines.hasTask">Yes</span>
          </td>
          <td *ngIf="summaryPage" class="text-center number">
            <a
              class="link no-decoration"
              (click)="
                isDisableLink
                  ? $event.preventDefault()
                  : showInputFieldForLineNote(
                      orderLines.lineRecIdD365,
                      orderLines.notes
                    )
              ">
              <i *ngIf="orderLines.notes === ''" class="pi pi-plus"></i>
              <i
                *ngIf="orderLines.notes !== ''"
                class="pi pi-pen-to-square"></i>
            </a>
          </td>
          <td></td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No record found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  [(visible)]="showUploadTracking"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="true"
  appendTo="body"
  styleClass="order-dialog"
  [header]="'Upload Tracking'">
  <!-- <button
    type="button"
    class="btn btn-primary mb-4"
    (click)="getWorkFlowTrackingExcelTemplate()">
    Download Template
  </button> -->

  <div class="mb-3">
    <p-button
      (click)="getWorkFlowTrackingExcelTemplate()"
      label="Download Template" />
  </div>

  <p-fileUpload
    #fileUpload
    name="file"
    (uploadHandler)="onUpload($event)"
    (onClear)="closeUploadTracking()"
    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    [customUpload]="true"
    class="jni-fileupload-hide-files"
    (onUpload)="onInputChange(true)">
    <ng-template
      pTemplate="content"
      let-files
      let-chooseCallback="chooseCallback">
      <div
        class="po-attachment-drag-drop-container"
        (dragover)="onDragOver($event)"
        (drop)="onFileDrop($event)"
        (dragleave)="onDragLeave($event)"
        (dragenter)="onDragEnter($event)">
        <div
          class="po-attachment-drag-drop-area"
          [class.drag-over]="isDragOver">
          <i class="pi pi-cloud-upload po-attachment-drag-drop-icon"></i>
          <div class="po-attachment-drag-drop-text">
            <p class="mb-2">Drag & Drop files here</p>
          </div>
        </div>
        <div
          *ngIf="files && files.length > 0"
          class="po-attachment-files-preview mt-2">
          <div
            *ngFor="let file of files"
            class="po-attachment-file-item d-flex align-items-center p-2 border rounded mb-1">
            <i class="pi pi-file text-primary me-2"></i>
            <div class="flex-grow-1">
              <div class="font-weight-bold small">{{ file.name }}</div>
              <div class="text-muted small">
                {{ formatFileSize(file.size) }}
              </div>
            </div>
            <p-button
              icon="pi pi-times"
              (click)="removeFile(file)"
              class="p-button-text p-button-sm">
            </p-button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>

  <ng-template pTemplate="footer">
    <div class="d-flex pt-2 justify-content-end">
      <!-- <button
        type="button"
        (click)="closeModalDialog()"
        class="btn btn-secondary me-3">
        Cancel
      </button> -->

      <p-button
        label="Cancel"
        (click)="closeModalDialog()"
        variant="outlined"
        severity="secondary" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Add Tracking Information"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="addTrackingModal"
  appendTo="body"
  [style]="{ width: '60vw', 'border-radius': '10px' }"
  styleClass="order-dialog">
  <jni-add-tracking
    (saveTrackingListEvent)="
      addTrackingData($event.trackingList, $event.isManualTracking)
    "
    [workflowTrackingList]="workflowTrackingList"
    [totalLineQuantity]="trackingLineQuantity"
    [vendorSKU]="trackingLineVendorSKU"
    [shippingMethod]="trackingLineShippingMethod"
    [lineRecIdD365]="trackingLineRecIdD365"
    (closeModalDialogEvent)="closeModalDialog()"
    (deleteTrackingRecordEvent)="deleteTrackingRecord($event)"
    [addTrackingLineNumber]="addTrackingLineNumber"
    [addTrackingPurchaseOrder]="addTrackingPurchaseOrder"
    [shippingMethodName]="trackingLineShippingMethodName">
  </jni-add-tracking>
</p-dialog>

<p-dialog
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="trackingListModal"
  [style]="{ width: '50vw', margin: '20px' }"
  styleClass="order-dialog"
  [closable]="true"
  appendTo="body">
  <ng-template pTemplate="header">
    <div class="tracking-header d-flex justify-content-between">
      <div class="d-flex gap-2">
        <h2 class="mb-0">Tracking Information</h2>
        <!-- <div
          class="lds-ring inline me-auto ms-2"
          *ngIf="smallTrackingListLoader">
          <div></div>
          <div></div>
          <div></div>
        </div> -->
      </div>
      <!-- <div>
        <button class="btn-cross" (click)="closeModalDialog()">
          <i class="icon-Cross"></i>
        </button>
      </div> -->
    </div>
  </ng-template>
  <!-- fixes/14757: original binding was [isDisableLink]="isDisableLink" -->
  <jni-tracking-list
    #trackingList
    [workflowTrackingList]="trackingDetailsList"
    [showDetailLinks]="true"
    [isDisableLink]="isDisableLink || disableAddTracking"
    (deleteTrackingRecordEvent)="deleteTrackingRecord($event)"
    (showTrackingDetailEvent)="showTrackingDetails($event)"
    (showTrackingHistoryEvent)="showTrackingHistory($event)"
    [showEdit]="true"
    (rowEditSaveEvent)="updateManualTrackingStatus($event)"
    (refreshGrid)="getWorflowLineTrackingList()">
  </jni-tracking-list>

  <div class="d-flex pt-2 justify-content-end gap-2">
    <!-- fixes/14757: original was (click)="openAddManualTrackingModal()", now opens the unified jni-add-tracking popup -->
    <p-button
      label="Add Tracking"
      [disabled]="disableAddTracking || isDisableLink"
      (click)="openAddTrackingFromList()" />

    <p-button
      label="close"
      (click)="closeModal()"
      variant="outlined"
      severity="secondary" />

    <!-- <button
      [disabled]="disableAddTracking || isDisableLink"
      type="button"
      class="btn btn-secondary me-3"
      (click)="openAddManualTrackingModal()">
      Add Tracking
    </button>
    <button type="button" class="btn btn-secondary me-3" (click)="closeModal()">
      close
    </button> -->
  </div>
</p-dialog>

<!-- fixes/14757: original header was header="Tracking" -->
<p-dialog
  [(visible)]="trackingHistoryModalOpen"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '35%' }"
  header="Tracking Status"
  appendTo="body">
  <jni-tracking-list-popup
    [trackingHistoryList]="trackingHistoryList"
    (displayChange)="closeTrackingModals()"
    [trackingNumber]="historyTrackingNumber"
    [shippingMethodName]="historyShippingMethodName"
    [estDelivery]="historyEstDelivery">
  </jni-tracking-list-popup>
</p-dialog>

<!-- fixes/14757: original header was header="Tracking Details" -->
<p-dialog
  header="Shipment Details"
  [(visible)]="trackingDetailsModalOpen"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '800px', margin: '20px 80px' }"
  appendTo="body">
  <jni-tracking-detail-popup
    (displayChange)="closeTrackingModals()"
    [trackingNumberDetail]="trackingDetailsBindingObj"
    [trackingDimension]="trackingDimension"
    [trackingWeight]="trackingWeight"
    [isUPS]="isUPS"
    (viewTimelineEvent)="viewTimelineFromShipmentDetails()">
  </jni-tracking-detail-popup>
</p-dialog>

<jni-notification-settings
  #lineNotificationSettings
  [viewSettingsModal]="viewSettingsModal"
  [notificationSettings]="notificationSettings"
  (closeUpdateSettingModalEvent)="showOrHideNotificationSettings()"
  [workflowId]="workflowId"
  [isGlobal]="false"
  (dailogHideEventSettings)="hideNotificationSettingDailog($event)"
  [lineRecIdD365]="notificationSettingLineRecId">
</jni-notification-settings>

<p-dialog
  header="Add Sales Order Lines"
  appendTo="body"
  [(visible)]="addWorkflowLinesModalDisplay"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '800px' }">
  <jni-add-workflow-lines
    [nonAddedLines]="nonAddedLines"
    (closeModalEvent)="closeAddLineModal()"
    (postLineRecIdListEvent)="addLinesToProjectWorkflow($event)">
  </jni-add-workflow-lines>
</p-dialog>

<jni-workflow-line-notes
  #linenotessidebar
  *ngIf="displaySidebarForNotes"
  [(display)]="displaySidebarForNotes"
  [projectWorkflowId]="workflowId"
  [lineRecId]="lineRecId"
  [notes]="notes"
  (closeSidebar)="closeSideBarForNotes()"
  (saveNotesEvent)="saveNotes($event)">
</jni-workflow-line-notes>

<!-- fixes/14757: manual "Add Tracking" dialog replaced by the unified jni-add-tracking popup (openAddTrackingFromList)
<p-dialog
  [(visible)]="displayAddManualTrackingModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '35%' }"
  header="Add Tracking"
  [closable]="true"
  appendTo="body">
  <div class="col">
    <div class="row">
      <div class="form-group has-float-label mb-2">
        <label class="form-label">Shipping Method</label>
        <p-select
          id="shippingMethod"
          [(ngModel)]="manualMethod"
          [options]="manualShippingMethods"
          optionLabel="shippingMethod"
          optionValue="code"
          appendTo="body"
          [filter]="true"
          [showClear]="true">
        </p-select>
      </div>
    </div>
    <div>
      <div class="form-group has-float-label mb-2">
        <label class="form-label">Tracking</label>
        <textarea
          pInputText
          jniAutoCompleteBlocker
          class="form-control"
          type="text"
          placeholder=""
          [(ngModel)]="trackings"></textarea>
      </div>
    </div>
  </div>
  <div class="d-flex pt-2 justify-content-end">
    <button
      type="button"
      class="btn btn-secondary me-3"
      (click)="addManualTrackingNumbers()">
      Add Tracking
    </button>

    <p-button label="Add Tracking" (click)="addManualTrackingNumbers()" />
  </div>
</p-dialog>
-->
